export const environment = {
  production: false,
  appVersion: require("../../package.json").version + "-development",
  APIBasePath: "https://api.trakk.dev/api/v1/",
  HereApiKey: "HGw26wciGrENHjiyX1DszhvfocXZrlRZysBxbxmlKyw",
  MapBannedCustomer: [216, 559, 703],
};
